
<div class="traffic-container">

  <div fxLayout="row" class="traffic-header" fxLayoutAlign="space-between center">
    <div fxLayoutAlign="start center" fxLayoutGap="10px" (click)="onSelect()" class="select-mode">
      <div i18n>
        {selectedMode, select, Trànsit en directe {Tránsito en directo} Trànsit en previsió {Tránsito en previsión}}
      </div>
      <div><img class="arrow" [class.selected]="selectedMode==='Trànsit en previsió'" src="assets/img/arrowButtonWhite.svg" alt=""></div>
    </div>
    <div class="toggle-container">
      <mat-slide-toggle (change)="emitEvent(true)"></mat-slide-toggle>
    </div>
  </div>


  <div *ngIf="selectedMode==='Trànsit en previsió'" class="transit-previsio" fxLayout="row" fxLayoutAlign="space-between center" fxLayoutGap="10px">
    <div fxFlex="50%" fxLayoutAlign="center center" fxLayoutGap="3px">
      <!--<img src="assets/img/date.svg" alt="Calendari">-->
      <input min="{{ minDate | date:'yyyy-MM-dd' }}" max="{{ maxDate | date:'yyyy-MM-dd' }}" [ngModel]="formattedDate" (ngModelChange)="changeDate($event)" type="date" required>
    </div>
    <div fxFlex="50%" class="custom-slider" fxLayoutAlign="center center" fxLayoutGap="10px">
      <img style="vertical-align: middle;" src="assets/img/clock.svg" alt="icona rellotge">
      <ng5-slider [(value)]="timeValue" [options]="options" (userChangeEnd)="updateTime()"></ng5-slider>
    </div>
  </div>


</div>

<div class="submenu-legend" *ngIf="consultarTransit" fxLayout="row">
  <div class="submenu-legend-colors"  i18n>
    Lento
  </div>
    <div
      title="Cerrado"
      class="legendDivColor"
      style="background-color: #000000;"
    ></div>
    <div
      title="0 - 50"
      class="legendDivColor"
      style="background-color: #FF5468;"
    ></div>
    <div
      title="51 - 75"
      class="legendDivColor"
      style="background-color: #FABE4D;"
    ></div>
    <div
      title="76 - 100"
      class="legendDivColor"
      style="background-color: #2DC937;"
    ></div>
    <div  i18n>
      Rápido
    </div>
    
</div>



